export const PAGES = {
  ENGAGEMENT_TEAM_PAGE: 'ET',
  CLIENT_TEAM_PAGE: 'CT',
  THIRD_PARTY_TEAM_PAGE: 'TT',
};

export const TABS = {
  MEMBERS: 'members',
  REQUESTS: 'requests',
};

export const ENGAGEMENT_HUB = 'Engagement Hub';
export const ENGAGEMENT_TEAM_OWNER = 'Engagement Team owners';
export const ET_TEAM_MEMBERS_PATH = 'team-members/engagement-team/members';
export const HOST_TYPE = 'Junction';
